import axiosInstance from '../utils/axiosInstance';
import { http } from '../utils/http';

const login = async (username, password) => {
  try {
    const payload = {};
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'applications/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        Email: username,
        Password: password,
      },
    };
    return await axiosInstance.post('/AuthManagement/Token', payload, requestOptions);
  } catch (error) {
    console.error('Login failed', error);
    throw new Error(error);
  }
};

const forgotPassword = async (username) => {
  try {
    const payload = {
      email: username,
    };
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'applications/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
      },
    };
    return await axiosInstance.put('/User/ForgotPassword', payload, requestOptions);
  } catch (error) {
    console.error('Invalid email', error);
    throw new Error(error);
  }
};

const refreshToken = async () => {
  try {
    const authToken = JSON.parse(localStorage.getItem('authentication'));
    const payload = {
      Token: authToken.token,
      RefreshToken: authToken.refreshToken,
    };
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'applications/json',
      },
    };
    return await axiosInstance.post('/AuthManagement/RefreshToken', payload, requestOptions);
  } catch (error) {
    console.error('Login failed', error);
    throw new Error(error);
  }
};

const logout = async () => {
  return await http.post('/logout', {});
};

export const authHandler = {
  login,
  refreshToken,
  logout,
  forgotPassword,
};
